import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import ContinueButton from "./ContinueButton";
import SecurityUpdateGoodIcon from "@mui/icons-material/SecurityUpdateGood";

const EUROPE_SCHEDULE_PHONE = "0577,704514";

const EuropeScheduleInfo = ({ submitting, handleUpdate }) => {
  const callToSchedule = () => {
    void handleUpdate("Schedule", { Step: "Schedule" });
    window.location.href = `tel:${EUROPE_SCHEDULE_PHONE}`;
  };

  return (
    <Grid
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        mt: 4,
        px: 2,
      }}
    >
      <ContinueButton
        submitting={submitting}
        onClick={callToSchedule}
        continueText="europe.callToSchedule"
        isLongWidth
        isStatic={true}
        isFullWidth
        showForwardIcon={false}
        showSavingIndicator={false}
        startIcon={<SecurityUpdateGoodIcon />}
      />
    </Grid>
  );
};

EuropeScheduleInfo.propTypes = {
  submitting: PropTypes.bool,
  handleUpdate: PropTypes.func.isRequired,
};

export default EuropeScheduleInfo;
